import {
  yleContextGenerator,
  activeEntityContextGenerator,
  searchContextGenerator,
  viewEventGenerator,
  wrapperContextGenerator,
} from 'services/snowplowAnalytics/contextGenerators';
import { trackPageView } from 'services/snowplowAnalytics/snowplowAnalytics';
import { Analytics, Language } from '@yleisradio/areena-types';

export function trackSearchSnowplowPageView(
  isSnowplowReady: boolean,
  countryCode: string | undefined,
  language: Language,
  analyticsSearchId: string,
  searchQuery: string
) {
  // api decided not to provide pageload object for us, so lets create it here.
  const searchAnalytics: Analytics = {
    pageload: {
      yle: {
        id: analyticsSearchId,
        search_phrase: searchQuery,
        areena_view_type: 'search',
        entity_type: 'search',
      },
    },
  };

  const ylePageloadAnalytics = searchAnalytics?.pageload?.yle;

  if (!isSnowplowReady || !ylePageloadAnalytics) {
    return;
  }

  const section = ylePageloadAnalytics['areena_view_type'] || 'page';
  const yleContext = yleContextGenerator({
    countryCode,
    language,
    section,
  });

  const activeEntity = activeEntityContextGenerator(
    ylePageloadAnalytics.entity_type,
    ylePageloadAnalytics.id,
    ylePageloadAnalytics.version,
    ylePageloadAnalytics.areena_view_type,
    ylePageloadAnalytics.search_phrase
  );

  trackPageView(yleContext, activeEntity);
}

type TrackSearchViewArgs = {
  isSnowplowReady: boolean;
  viewUuid: string;
  searchQuery: string;
  service: string;
  viewMode: 'overlay' | 'full';
};

export const trackSearchEngagementView = ({
  isSnowplowReady,
  viewUuid,
  searchQuery,
  service,
  viewMode,
}: TrackSearchViewArgs) => {
  if (!isSnowplowReady || !window.yleSnowplow) {
    return;
  }
  const viewEvent = viewEventGenerator(viewUuid, 'entity', viewMode, 'search');
  const id = service === 'radio' ? 'areena_podcast' : 'areena_tv';
  const context = [
    searchContextGenerator(id, searchQuery, 'engagement_view_target'),
    ...(viewMode === 'overlay'
      ? [wrapperContextGenerator({ type: viewMode, label: 'search' })]
      : []),
  ];

  window.yleSnowplow('trackSelfDescribingEvent', {
    event: viewEvent,
    context,
  });
};
